module.exports = __webpack_public_path__ + "static/media/28.489e1aa6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/28.jpg
// module id = 289
// module chunks = 0